<template>
	<div>
		<div class="upload_docs_header personalize-header">
			<h1 class="pr-3">Personalize</h1>
			<modal-help>
                In personalize document, investment will be grouped into closed dates, you can expand tranches and see individual investment and pick the
				following types (Tax Form, Subscription, and Other) to upload files
            </modal-help>
		</div>
		<div v-if="error" class="error-container">
			<h2 class="error-heading">
				<i class="fa fa-exclamation-circle"></i> Whoops!
				<!-- <span>Please correct the following errors:</span> -->
			</h2>
			<ul>
				<li><i class="fa fa-exclamation"></i>{{ error }}</li>
			</ul>
		</div>
		<input class="form-control search-personal-doc mb-2 mr-sm-2" type="text" placeholder="Filter By Name" v-model="searchText" />
		
		<div class="text-center" v-if="loading">
            <img src="../../../images/loader.gif" height="100px" width="100px" />
            <p>Please wait ... </p>
        </div>
		<table class="table table-hover table-striped table-condensed tranches investment-table" v-else>
			<thead>
				<tr>
					<th>Status</th>
          			<th>Date</th>
					<th>No. of Investors</th>
					<th>Aggregate Subscriptions</th>
					<th>Action</th>
					<th>Subscriber Details</th>
				</tr>
			</thead>
			<tbody>
				<template v-for="(tranch, key) in tranches">
					<tr
						class="tranch-rollup"
						data-toggle="collapse"
						@click="expandTranch(tranch.index)"
					>
						<td class="tranche-status">{{ tranch.status }}</td>
						<td class="tranche-status">{{ key }}</td>
						<td class="tranche-status">{{ tranch.investments.length }}</td>
						<td class="tranche-status">{{ formatCurrency(tranch.totalAmount) }}</td>
						<td class="tranche-status">
							<input
								v-if="checkedInvestments[tranch.index] && checkedInvestments[tranch.index].length > 0"
								class="btn btn-sm btn-default"
								@click.stop="sendPersonalEmail(tranch.index)"
								value="Send Email"
								type="button"
							/>
						</td>
						<td><i class="glyphicon glyphicon-chevron-up"></i></td>
					</tr>
					<tr :class="`accordion-body`" v-if="expandedTranches[`investmentsTable${tranch.index}`]">
							<td colspan="6" class="hiddenRow">
								<table class="table investment-table">
									<thead>
										<tr className="py-3">
											<th width="20"></th>
											<th class="fixed-td">Subscriber Name</th>
											<th class="id-row" style="width: 10%;">Investor ID</th>
											<th class="id-row" style="width: 10%;">Investment ID</th>
											<th>Tax Form</th>
											<th>Subscription</th>
											<th>Others</th>
										</tr>
									</thead>
									<tr v-for="investment in tranch.investments">
										<td>
											<input
												:ref="`checkbox-investment-${investment.id}`" 
												type="checkbox"
												:checked="isChecked(tranch, investment)"
												@change="checkInvestmentToSendEmail($event, tranch.index, investment)"
											/>
										</td>
										<td>{{ investment.name }}</td>
										<td>{{ investment.userId }}</td>
										<td>{{ investment.investmentId }}</td>
										<personalize-document-link :investment="investment" :tag="'tax-form'" :getDownloadLink="getDownloadLink"
											:onFilePicked="onFilePicked" :doesDocumentExist="doesDocumentExist" :activeEmd="activeEmd"
											:offering="offering" :refName="'taxFormFileInput' + investment.investmentId" :deleteFile="deleteFile" :tranchIndex="tranch.index" />
										<personalize-document-link :investment="investment" :tag="'subscription'" :getDownloadLink="getDownloadLink"
											:onFilePicked="onFilePicked" :doesDocumentExist="doesDocumentExist" :activeEmd="activeEmd"
											:offering="offering" :refName="'subscriptionFileInput' + investment.investmentId" :deleteFile="deleteFile" :tranchIndex="tranch.index" />
										<personalize-document-link :investment="investment" :tag="'other'" :onFilePicked="onFilePicked"
											:getDownloadLink="getDownloadLink" :doesDocumentExist="doesDocumentExist" :activeEmd="activeEmd"
											:offering="offering" :refName="'othersFileInput' + investment.investmentId" :deleteFile="deleteFile" :tranchIndex="tranch.index" />
									</tr>
								</table>
							</td>
						</tr>
				</template>
			</tbody>
		</table>
		<pagination :data="investmentsOptions" @pagination-change-page="loadAndGetInvestments" :limit="1"></pagination>
	</div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import pagination from "laravel-vue-pagination"

import { doesDocumentExist, getDownloadLink } from './services';
import { formatCurrency } from '../investor/dashboard/services';
import PersonalizeDocumentLink from './PersonalizeDocumentLink';
import ModalHelp from '../ModalHelp';

export default {
	data() {
		return {
			uploader: null,
			error: null,
			expandedTranches: {},
			checkedInvestments: {},
			searchText: '',
			loading: false,
		}
	},
	props: {
		investmentsOptions: {
			type: Object,
		},
		personalDocs: {
			type: Array,
			default: [],
		},
		offering: {
			type: Object,
		},
		activeEmd: {
			type: Object,
		},
		fileUploaded: {
			type: Function,
		},
		deletePersonalDoc: {
			type: Function,
		},
		sendPersonalUpdateEmails: {
			type: Function,
		},
		getPersonalDocument: {
			type: Function,
		}
	},
	methods: {
		doesDocumentExist(investment, tag) {
			return doesDocumentExist(investment, tag);
		},
		getDownloadLink(doc) {
			return getDownloadLink(doc);
		},
		onClickButtonUpload(investmentId, refName) {
			this.$refs[refName + '' + investmentId][0].click();
		},
		onFilePicked(event, tag, tranchId, investment) {
			const files = event.target.files
			return this.uploadFile(files, tag, tranchId, investment)
		},
		async uploadFile(files, tag, tranchId, investment) {
			let token = $('meta[name="csrf-token"]').attr('content')
			const fileReader = new FileReader()
			let isUploading = true
			fileReader.addEventListener('load', () => {
				const formData = this.constructFormData(files, investment, tag);
				const config = {
					headers: {
						'content-type': 'multipart/form-data',
						'X-CSRF-TOKEN': token
					}
				};
				axios.post('/upload/post', formData, config)
					.then(response => {
						const { error, doc, file } = response.data || {}
						if (error) {
							this.error = error
						} else {
							this.error = null
							this.checkInvestmentToSendEmail(null, tranchId, investment, true);
							this.fileUploaded({
								...doc,
								file_id: file.id,
							});
						}
						
					})
					.catch(error => {
						this.error = error
						isUploading = false;
					});
			})
			fileReader.readAsDataURL(files[0])
			return isUploading
		},
		async deleteFile(documentId, tranchId, investment) {
			const deleteUrl = `/admin/${this.activeEmd.slug}/offerings/${this.offering.id}/docs/${documentId}/delete`
			let isDeleting = true
			axios.get(deleteUrl)
				.then(_response => {
					let filesLeft = 0;
					if (investment.documents['other']) {
						filesLeft++;
					}
					if (investment.documents['subscription']) {
						filesLeft++;
					} 
					if (investment.documents['tax-form']) {
						filesLeft++;
					} 
					// Will check if no files is left, then uncheck the checkbox,
					if (filesLeft <= 1) {
						this.checkInvestmentToSendEmail(null, tranchId, investment);
					}
					this.deletePersonalDoc(documentId);
					isDeleting = false
				})
				.catch(error => {
					this.error = error
					isDeleting = false
				});
			return isDeleting
		},
		constructFormData(files, investment, tag) {
			const formData = new FormData();
			const fileSize = files[0].size
			const filename = files[0].name
			formData.append('qqfile', files[0], filename);
			formData.append('qqfilename', filename);
			formData.append('qqtotalfilesize', fileSize);
			formData.append('offeringId', this.offering.id);
			formData.append('is_read_only', false);
			formData.append('tag', tag);
			formData.append('is_personal', true);
			formData.append('investment_id', investment.investmentId);
			formData.append('investor_id', investment.userId);
			formData.append('order', 1);
			formData.append('emd_slug', this.activeEmd && this.activeEmd.slug)
			return formData
		},
		formatCurrency(amount) {
			return formatCurrency(amount);
		},
		expandTranch(id) {
			this.expandedTranches = {
				...this.expandedTranches,
				[`investmentsTable${id}`]: !this.expandedTranches[`investmentsTable${id}`]
			}
		},
		sendPersonalEmail(tranchId) {
			const investmentIds = this.checkedInvestments[tranchId].map(inv => inv.id)
			this.sendPersonalUpdateEmails(investmentIds)
				.then((_isSent) => {
					this.checkedInvestments[tranchId] = []
				})
		},
		checkInvestmentToSendEmail(_event, tranchId, investment, uploading = false) {	
			if(this.checkedInvestments[tranchId]) {
				if (!this.checkedInvestments[tranchId].find(inv => inv.investmentId === investment.investmentId)) {
					this.checkedInvestments[tranchId].push(investment);
				} 
				else {
					if(!uploading) {
						this.checkedInvestments[tranchId] = this.checkedInvestments[tranchId].filter(inv => inv.investmentId !== investment.investmentId);
					}
				}
			}
			else {
					this.checkedInvestments[tranchId] = [investment];
			}
		},
		isChecked(tranch, investment) {
			return (this.checkedInvestments[tranch.index] || []).find(inv => inv.investmentId === investment.investmentId)
		},
		loadAndGetInvestments(page = 1) {
			this.loading = true
			for (const key in this.expandedTranches) {
				this.expandedTranches[key] = false;
			}
			this.getPersonalDocument(page)
				.then(() => {
					this.loading = false
				})
		},
		initializeTranches() {
			this.expandedTranches = this.investmentsOptions.data.reduce((acc, _inv, index) => {
			const key = `investmentsTable${index}`;
			index++;
			return {
				...acc,
				[key]: false
			};
			}, {});
			this.checkedInvestments = this.investmentsOptions.data.reduce((acc, _inv, index) => {
				return {
					...acc,
					[index]: [],
				};
			}, {});
		}
	},
	computed: {
		getCompletedOn() {
			const dateStr = this.investmentsOptions.data.find(item => item.closedOn)?.closedOn || null;
			if (dateStr) {
				return new Date(dateStr).toLocaleDateString();
			} else {
				return null;
			}
		},
		investmentCompleted() {
			return this.investmentsOptions.data.length
		},
		tranches() {
			return this.investmentsOptions.data
				.filter((inv) => {
					if (this.searchText === '') {
						return true
					} else {
						const matchesInvestorName = inv.name.toLowerCase().includes(this.searchText.toLowerCase())
						return matchesInvestorName
					}
				})
				.reduce((acc, inv, index) => {
					const { status, closedOn, amount } = inv;
					const key = inv.status === 'complete' ? closedOn : status;
					return {
						...acc,
						[key]: {
							investments: acc[key] && acc[key].investments && acc[key].investments.length > 0 ? [...acc[key].investments, inv] : [inv],
							totalAmount: acc[key] && acc[key].totalAmount ? acc[key].totalAmount + Number(amount) : Number(amount),
							index,
							status,
						},
					};
				}, {});
		}
	},
	watch: {
		searchText(newSearchText) {
			if (newSearchText) {
				for (const key in this.expandedTranches) {
					this.expandedTranches[key] = true;
				}
			} else {
				for (const key in this.expandedTranches) {
					this.expandedTranches[key] = false;
				}
			}
		},
		investmentsOptions() {
			this.initializeTranches();
		}
	},
	mounted() {
		this.initializeTranches();
	},
	components: {
		PersonalizeDocumentLink,
		ModalHelp,
		pagination,
	},
}
</script>